import { twMerge } from 'tailwind-merge';
import type { AlignerFormData } from '@witmetrics/utils';
import ToggleBlock, { ToggleOption } from '@/components/ToggleBlock';
import { classes, styles } from './utils';

export type TreatmentFormProps = {
  className?: string;
  data: AlignerFormData;
  onChange: (data: AlignerFormData) => void;
};

export default function TreatmentForm({
  className,
  data,
  onChange,
}: TreatmentFormProps) {
  const renderOption = (value: string, count = 2) => {
    return (
      <ToggleOption
        sx={styles.option(count)}
        className={classes.option}
        value={value}>
        {value}
      </ToggleOption>
    );
  };
  return (
    <div className={twMerge(classes.wrapper, className)}>
      <div className={classes.fieldWrapper}>
        <label className={classes.label}>Arch to Treat</label>
        <ToggleBlock<AlignerFormData['archToTreat']>
          value={data.archToTreat}
          onChange={(archToTreat) => onChange({ ...data, archToTreat })}>
          {renderOption('Both', 3)}
          {renderOption('Upper', 3)}
          {renderOption('Lower', 3)}
        </ToggleBlock>
      </div>
      <div className={classes.fieldWrapper}>
        <label className={classes.label}>Spacing</label>
        <ToggleBlock<AlignerFormData['spacing']>
          value={data.spacing}
          onChange={(spacing) => onChange({ ...data, spacing })}>
          {renderOption('Maintain')}
          {renderOption('Close all')}
        </ToggleBlock>
      </div>
      <div className={classes.fieldWrapper}>
        <label className={classes.label}>Midline</label>
        <ToggleBlock<AlignerFormData['midline']>
          value={data.midline}
          onChange={(midline) => onChange({ ...data, midline })}>
          {renderOption('Maintain')}
          {renderOption('Correct')}
        </ToggleBlock>
      </div>
      <div className={classes.fieldWrapper}>
        <label className={classes.label}>Overjet</label>
        <ToggleBlock<AlignerFormData['overjet']>
          value={data.overjet}
          onChange={(overjet) => onChange({ ...data, overjet })}>
          {renderOption('Maintain')}
          {renderOption('Correct')}
        </ToggleBlock>
      </div>
      <div className={classes.fieldWrapper}>
        <label className={classes.label}>Overbite</label>
        <ToggleBlock<AlignerFormData['overbite']>
          value={data.overbite}
          onChange={(overbite) => onChange({ ...data, overbite })}>
          {renderOption('Maintain')}
          {renderOption('Correct')}
        </ToggleBlock>
      </div>
      <div className={classes.fieldWrapper}>
        <label className={classes.label}>Posterior Crossbite</label>
        <ToggleBlock<AlignerFormData['posteriorCrossbite']>
          value={data.posteriorCrossbite}
          onChange={(posteriorCrossbite) =>
            onChange({ ...data, posteriorCrossbite })
          }>
          {renderOption('Maintain')}
          {renderOption('Correct')}
        </ToggleBlock>
      </div>
    </div>
  );
}
